import { getEnvToHeader } from '@/config/interceptors/abEnv'
import VM from '@/main'
import { isArray } from 'lodash'
import sensors from './sensorsdata.full'

let title = ''
let pageKey = '' // 页面访问一次所需要的唯一key

const serverUrl =
  document.domain === 'localhost' || document.domain.indexOf('192.168.0') >= 0
    ? process.env.VUE_APP_BASE_API
    : `https://${document.domain}/api`

sensors.init({
  server_url: `${serverUrl}/blank?env=${getEnvToHeader()}`,
  is_track_single_page: false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  // use_client_time: true,
  show_log: false,
  send_type: 'ajax',
  batch_send: true, // 开启批量发送
  heatmap: {
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
    track_attr: ['sensorsTrack'], // 设置属性上传，有阻止冒泡的别用这个，要手动调用上报
    collect_element: (element_target) => {
      const sensorsTrack = element_target.getAttribute('sensorsTrack')
      if (sensorsTrack) {
        return true
      } else {
        return false
      }
    },
    custom_property: (element_target) => {
      const sensorsTrack = element_target.getAttribute('sensorsTrack')
      if (sensorsTrack) {
        return { platForm: 'pc', name: sensorsTrack }
      }
    },
  }
})

sensors.setWebClick = ({ name, content }) => {
  sensors.track('$WebClick', {
    platForm: 'base-app',
    name,
    content: isArray(content) ? content.join(',') : content,
    title,
    pageKey,
  })
}

sensors.pageTrace = ({ refererName = VM.$route.meta.title, url = VM.$route.fullPath } = {}) => { // 上报页面埋点
  title = refererName
  pageKey = VM.$idV4()
  sensors.quick('autoTrackSinglePage', {
    platForm: 'base-app',
    title: refererName,
    pageKey,
  })
}

export default sensors
